import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function initGsapSticker() {
    function gsapSticker(track) {
        const item = track.querySelector("[sticky-item]");
        if (!item) return;

        const startOffset = item.offsetTop - track.offsetTop;
        const headerOffset = APP_HEADER_HEIGHT * 1.5;

        ScrollTrigger.create({
            markers: false,

            pin: item,
            pinSpacing: false,

            trigger: track,
            start: `top+=${startOffset} top+=${headerOffset}`,
            end: `bottom top+=${headerOffset + item.offsetHeight}`,

            toggleClass: { targets: item, className: "is-stuck" },
        });
    }
    gsap.utils.toArray("[sticky-track]").forEach(gsapSticker);
}
